import React, { useState } from 'react'
import { Footer, Header } from '../common/pages'
import { Button, Image } from 'react-bootstrap'
import cancle from '../../assets/images/input-cancle-image.svg';
import Phone from '../../assets/images/Phone-contact.svg';
import Location from '../../assets/images/Location-contact.svg';
import Mail from '../../assets/images/Mail-contact.svg';
export default function ContactUs() {
  const [contInfo, setContactInfo] = useState({ name: '', email: "", reason: "", message: "" });
  const { name, email, reason, message } = contInfo;

  function submitHandler(e) {
    e.preventDefault();
  }
  function onchangHandler(e) {
    setContactInfo({ ...contInfo, [e.target.name]: e.target.value });
  }
  const reSetName = (ele) => setContactInfo({ ...contInfo, [ele]: '' })
  return (
    <div>
      <Header />
      <div className="contact-us-section">
        <div className="w-100">
          <div className="contact-us-wrapper w-100">
            <div className="left-wrapper">
              <div className="contact-form-frame">
                <h4 className='lato-regular fs-32-18 black-242'>Contact Us</h4>
                <p className='lato-semibold fx-16 black-242'>We love hearing from you! Contact us for any inquiries or comments – <br /> we're here to help!</p>
                <form className='contacr-form' onSubmit={submitHandler} >
                  <div className="contacr-input-frame">
                    <input type="text" required className='input-box fx-16 lato-regular' placeholder='Name' value={name} name='name' onChange={onchangHandler} />
                    {name &&
                      <Image src={cancle} onClick={() => reSetName('name')} alt="cancle" className="input-cancle-img pointer" />
                    }
                  </div>
                  <div className="contacr-input-frame">
                    <input type="email" required className='input-box fx-16 lato-regular' placeholder='E-mail' value={email} name='email' onChange={onchangHandler} />
                    {
                      email &&
                      <Image src={cancle} alt="cancle" onClick={() => reSetName('email')} className="input-cancle-img pointer" />
                    }
                  </div>
                  <div className="contacr-input-frame">
                    <input type="text" className='input-box fx-16 lato-regular' placeholder='Reason for contact' value={reason} name='reason' onChange={onchangHandler} />
                    {
                      reason &&
                      <Image src={cancle} alt="cancle" onClick={() => reSetName('reason')} className="input-cancle-img " />}
                  </div>
                  <textarea className='contact-text-area  fx-16 lato-regular' placeholder='Message' id="" cols="30" rows="6" value={message} name='message' onChange={onchangHandler}></textarea>
                  <div className="contact-submit-btn">
                    <Button className="primary-btn " type='submit'>
                      Submit
                    </Button>
                  </div>
                </form>
              </div>
            </div>
            <div className="contact-info-frame">
              <ul className='conteact-info-wrapper'>
                <li className=' lato-regular fx-16 black-242'><Image src={Location} alt='image' /> 7th Floor, Merchant Chambers, Vitthaldas Thackersey Marg, New Marine Lines, Churchgate, Mumbai, Maharashtra 400020</li>
                <li className=' lato-regular fx-16 black-242'><Image src={Phone} alt='image' /> <a className=' lato-regular fx-16 black-242' href="tel:+918356094696"> +91 83560 94696 </a></li>
                <li className=' lato-regular fx-16 black-242'><Image src={Mail} alt='image' /> <a className=' lato-regular fx-16 black-242' href="mailto:info@thefinpedia.com">info@thefinpedia.com</a></li>
              </ul>

            </div>
            {/* <textarea className='contact-text-area  fx-16 lato-regular' value={massage} onChange={contactChangeHandler} name='massage' maxLength={250} placeholder='Message' id="" cols="30" rows="6"></textarea>
                  <div className="contact-submit-btn">
                    <Button className="primary-btn " type='submit'>
                      Submit
                    </Button>
                  </div> */}
            {/* </form> */}
          </div>
        </div>
      </div>
      {/* </div>
      </div > */}
      <Footer />
    </div >
  )
}
